import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledActionsButtonLink } from '../StyledComponents';
import { StyledPipe } from './StyledPipe';
import ViewDownloadSourceModalDialog from './DownloadSourceModal';

export const DownloadSourceLink = ({ productKey }) => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  return (
    <>
      {/* Add analytics for it */}
      <StyledActionsButtonLink
        appearance="link"
        href={`/purchase/my/download-source/${productKey}`}
        data-cy="actions-section-download-source-button"
      >
        <FormattedMessage id="mac.licenses.download.source" defaultMessage="Download Source" />
      </StyledActionsButtonLink>
      <StyledPipe />
      <ViewDownloadSourceModalDialog
        isModalOpened={isModalOpened}
        onClose={() => setIsModalOpened(false)}
      />
    </>
  );
};
